import { dataHamburger } from 'dls-icons-data'
import { createIcon } from '../common'

const IconHamburger = /*#__PURE__*/createIcon(dataHamburger)
export default IconHamburger
